import DropdownMenu from './DropdownMenu';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme)=> ({
    menuItem: {
        ...theme.palette.background.menu.inactive,
        "&:hover": {
            ...theme.palette.background.menu.hover,
        },
        "&:active": {
            ...theme.palette.background.menu.active,
        },
    },
    selectedMenu: {
        ...theme.palette.background.menu.active,
        "&:hover": {
            ...theme.palette.background.menu.active,
        },
    },
}));


export default function SingleSelectMenu({ items, handleChange: onChange, open, onClose, ...props }) {

    const [state, setState] = React.useState({
        selected: null,
    });

    function _handleClick(e, clickedItem) {
        const newState = {
            ...state
        };

        newState.selected = newState.selected === clickedItem.id ? null : clickedItem.id;
        setState(newState);

        onChange?.call(this, e, clickedItem, newState, setState);
    }

    return (
        <DropdownMenu open={open} onClose={onClose} {...props} padding={0}>
            <MenuItems items={items} selected={state.selected} handleClick={_handleClick} />
        </DropdownMenu>
    );
}

function MenuItems({ items, selected, handleClose: onClose, handleClick: onItemClick }) {
    const classes = useStyles();

    const primaryTypographyProps = {
        variant: "subtitle1",
    };

    return (
        <>
            {items.map((item) => (
                <MenuItem 
                    className={classes.menuItem + " " + (selected === item.id ? classes.selectedMenu : '')} 
                    key={item.id} 
                    onClick={e => {
                        onClose?.(e);
                        onItemClick?.call(this, e, item);
                    }}
                    tabIndex={0}
                >
                    <ListItemText primary={item.label} primaryTypographyProps={primaryTypographyProps} />
                </MenuItem>
            ))}
        </>
    );
}